import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioIniciarSesion } from "../../configuracion/apiUrls";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import ModalRegistroCliente from "./ModalRegistroClienteV2";
import { NegocioConfig } from "../../configuracion/Empresa";
import { IdentificarEstacion } from "../../componentes/estacion/Estacion";
import IniciarSesionGoogle from "../../componentes/googlemap/SesionGoogle";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setLogin, setEstacion } = useContextUsuario();

  const navigate = useNavigate();

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("expirado") === "true") {
      mostraAlerta("Su sesión ha expirado o no es válida. Por favor, vuelva a iniciar sesión.", "warning");
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      mostraAlerta("Complete los campos", "warning");
      return;
    }

    try {
      const response = await AxiosPublico.post(UsuarioIniciarSesion, {
        login: username,
        contrasena: password,
      });

      const { data } = response;

      if (!data.Usuario || !data.Token) {
        mostraAlerta("Credenciales inválidas", "warning");
        return;
      }

      const { Usuario: usuario, Token: token } = data;

      mostraAlerta(`Bienvenido(a) ${usuario.datoPersonales.nombreCompleto}`, "success");
      await setLogin({ usuario, token });
      const datos = await IdentificarEstacion(usuario.id);
      await setEstacion(datos);
      //console.log("Usuario:", usuario);
      if (usuario.tipo === "Cliente") {
        navigate("/app/clientes/");
      } else if (usuario.tipo === "Empleado") {
        const accesoActivo = (usuario.accesos || []).find(a => a.estado === "Activo");
        if (accesoActivo && accesoActivo.ruta) {
          navigate(accesoActivo.ruta);
        } else {
          mostraAlerta("No tiene accesos activos asignados", "warning");
          navigate("/app/admin/empleados/");
        }
      } else {
        navigate("/app/home");
      }

    } catch (error) {
      //console.error("Error completo:", error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400 && Array.isArray(data)) {
          data.forEach((err) => {
            mostraAlerta(err.msg, "warning");
          });
        } else if (data && data.error) {
          mostraAlerta(data.error, "warning");
        } else {
          mostraAlerta("Error del servidor. Por favor, inténtalo de nuevo más tarde.", "warning");
        }
      } else if (error.request) {
        mostraAlerta("Error de conexión. Verifica tu conexión a internet.", "warning");
      } else {
        mostraAlerta("Error inesperado. Por favor, inténtalo de nuevo.", "warning");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div
          className="login-logo"
          style={{ display: "flex", justifyContent: "center" }}
        >
          {/* Agrega aquí el logotipo de tu aplicación */}
          <img
            src={NegocioConfig.logo}
            alt="SIGVEM LOGO"
            className="img-fluid img-circle"
            style={{
              width: "250px",
              height: "250px",
            }} />
        </div>
        <div className="card card-outline">
          <div className="card-body">
            <h4 className="login-box-msg">Inicio de sesión</h4>
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nombre de usuario"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-user"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />

                <div className="input-group-append">
                  <div
                    className="input-group-text"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      className={
                        showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                      }
                    ></span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block btn-lg"
                  >
                    Iniciar Sesión
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="text-center mt-3">
          <Link to="/recuperar-pin" className="forgot-password text-primary">
            Olvidaste tu Contraseña
          </Link>
        </div>
        <IniciarSesionGoogle />
        <div className="text-center mt-3">{<ModalRegistroCliente />}</div>
      </div>
    </div>
  );
};

export default Login;
